<template>
  <div
    class="eachendcompiler--mask"
    v-if="dialogVisible"
  >
    <div class="eachendcompiler--dialog">
      <i class="eachendcompiler--dialog-icon" @click="dialogClose">
        <img src="../assets/images/close_white.png" alt="">
      </i>
      <div class="eachendcompiler--dialog-txt">
        <div class="header" :style="[setStyle('vice','backgroundColor')]">
          报名成功
        </div>
        <div class="content">
          <p>恭喜你报名成功{{websiteName}}</p>
          <p>期待你在这次的比赛中取得好的成绩！</p>
          <button class="dialog_btn" @click="dialogClose" :style="[setStyle('vice','backgroundColor'),setStyle('main','color')]">我知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setColor } from '../utils/style';
import { mapState } from 'vuex'
export default {
    name:'signUpScuess',
    props:{
      dialogVisible:{
        type:Boolean,
        default:false
      },
      onSuccess:{
        type:Function,
        default:()=>{}
      }
    },
    computed:{
      ...mapState({
        globalConfig: state => state.router.globalConfig,
        websiteName:state => state.router.websiteName,
      }),
    },
    methods:{
      dialogClose(){
        this.$emit('update:dialogVisible',false)
        this.onSuccess();
      },
      setStyle(key, type) {
        return setColor(this.globalConfig, key, type);
      },
    }

}
</script>
<style lang="less" scoped>
.eachendcompiler {
  position: relative;
  min-width: 100%;
  height: 100%;
  &--mask {
    min-width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(17,17,17,.7);
    z-index: 99999;
  }
  &--dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 410px;
    height: 270px;
    border-radius: 20px;
    box-shadow: 0px 1px 5px 0px #9b9b9b;
    background-color: #fff;
    transform: translate(-50%,-50%);
    .header{
      height: 63px;
      position: relative;
      text-align: center;
      line-height: 63px;
      font-size: 24px;
      font-weight: 500;
      color:#fff;
      border-radius: 20px 20px 0 0;
    }
    &-icon{
      position: absolute;
      top:14px;
      right:14px;
      z-index: 99;
      cursor: pointer;
      img{
        width: 17px;
        height: 17px;
      }
    }
    .content{
      margin:32px 0 28px 0;
      p{
        margin: 0;
        padding: 0;
        font-size: 16px;
        color:#333;
        line-height: 30px;
      }
      .dialog_btn{
        height: 38px;
        line-height: 38px;
        padding:0 40px;
        border:none;
        border-radius: 20px;
        font-size: 16px;
        font-weight: 500;
        outline: none;
        cursor: pointer;
        margin-top:30px;
      }
    }
    &-txt {
      text-align: center;
      h3 {
        margin: 0;
        padding: 0;
        font-size: 24px;
        font-weight: 500;
        color: #38261E;
      }
      h5 {
        margin: 0;
        padding: 0;
        font-size: 16px;
        font-weight: 400;
        color: #9B9B9B;
      }
    }
  }
}

</style>
